import { CodeText } from '../redux/reducers/codetable/model'

export interface Option {
  value: string
  label: string
}

export const toOptions = (codetableImmutableData: any): Option[] =>
  codetableImmutableData.asMutable().map((item: CodeText) => ({
    value: item.code,
    label: item.text,
  }))

export const keyToOption = (options: CodeText[] = [], key: string) =>
  options.find((item: CodeText) => item.code === key)
